export const TESTIDS = {
  // Landing
  langToggle: "lang-toggle",
  navSignin: "nav-signin",
  navStart: "nav-start",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  serviceCard1: "service-card-1",
  serviceCard2: "service-card-2",
  serviceCard3: "service-card-3",
  serviceCard4: "service-card-4",
  packageCard1: "package-card-1",
  packageCard2: "package-card-2",
  packageCard3: "package-card-3",
  packageCard4: "package-card-4",
  intakeForm: "intake-form",
  intakeCompany: "intake-company",
  intakeContact: "intake-contact",
  intakeEmail: "intake-email",
  intakePhone: "intake-phone",
  intakeDealType: "intake-deal-type",
  intakeBrief: "intake-brief",
  intakeUrgency: "intake-urgency",
  intakeSubmit: "intake-submit",
  intakeSuccess: "intake-success",
  intakeError: "intake-error",
  footerContact: "footer-contact",

  // Auth
  authEmail: "auth-email",
  authPassword: "auth-password",
  authName: "auth-name",
  authCompany: "auth-company",
  authSubmit: "auth-submit",
  authToggle: "auth-toggle",
  authError: "auth-error",

  // Iteration C — Company Profile
  cpLegalName: "cp-legal-name",
  cpRegistration: "cp-registration",
  cpVat: "cp-vat",
  cpRegisteredAddress: "cp-registered-address",
  cpOperationalAddress: "cp-operational-address",
  cpCountry: "cp-country",
  cpWebsite: "cp-website",
  cpPhone: "cp-phone",
  cpEmail: "cp-email",
  cpDefaultCurrency: "cp-default-currency",
  cpDefaultLanguage: "cp-default-language",
  cpBankDetails: "cp-bank-details",
  cpFooter: "cp-footer",
  cpSignAdd: "cp-sign-add",
  cpSignRemove: "cp-sign-remove",
  cpSignName: "cp-sign-name",
  cpSignTitle: "cp-sign-title",
  cpSignAuthority: "cp-sign-authority",
  cpSaveBtn: "cp-save-btn",

  // Iteration C — Counterparties
  ctpNewBtn: "ctp-new-btn",
  ctpSearch: "ctp-search",
  ctpRow: "ctp-row",
  ctpEdit: "ctp-edit",
  ctpDelete: "ctp-delete",
  ctpLegalName: "ctp-legal-name",
  ctpType: "ctp-type",
  ctpCountry: "ctp-country",
  ctpAddress: "ctp-address",
  ctpVat: "ctp-vat",
  ctpBank: "ctp-bank",
  ctpRisk: "ctp-risk",
  ctpNotes: "ctp-notes",
  ctpContactAdd: "ctp-contact-add",
  ctpContactName: "ctp-contact-name",
  ctpContactRole: "ctp-contact-role",
  ctpContactEmail: "ctp-contact-email",
  ctpContactPhone: "ctp-contact-phone",
  ctpContactRemove: "ctp-contact-remove",
  ctpWebsite: "ctp-website",
  ctpModalClose: "ctp-modal-close",
  ctpSaveBtn: "ctp-save-btn",
  ctpCancelBtn: "ctp-cancel-btn",

  // Iteration D — Deal tabs
  dealTabOverview: "deal-tab-overview",
  dealTabData: "deal-tab-data",
  dealTabDocuments: "deal-tab-documents",
  dealTabFiles: "deal-tab-files",
  dealTabCorrespondence: "deal-tab-correspondence",
  dealTabAssistant: "deal-tab-assistant",
  dealTabActivity: "deal-tab-activity",
  dealDataSave: "deal-data-save",

  // Iteration E — Document Studio
  studioMode: "studio-mode",
  studioModeCreate: "studio-mode-create",
  studioModeReview: "studio-mode-review",
  studioModeImprove: "studio-mode-improve",
  studioModeTranslate: "studio-mode-translate",
  studioModeCompare: "studio-mode-compare",
  studioModeAdapt: "studio-mode-adapt",
  studioModeReply: "studio-mode-reply",
  studioModeHelp: "studio-mode-help",
  studioRiskBadge: "studio-risk-badge",
  studioMissingRequired: "studio-missing-required",
  studioSourceText: "studio-source-text",
  studioSchemaField: "studio-schema-field",  // prefix — appended with .{name}

  // Dashboard
  dashNavDashboard: "dash-nav-dashboard",
  dashNavDeals: "dash-nav-deals",
  dashNavTasks: "dash-nav-tasks",
  dashNavNotifications: "dash-nav-notifications",
  dashNavStudio: "dash-nav-studio",
  dashNavDrafting: "dash-nav-drafting",
  dashNavReview: "dash-nav-review",
  dashNavTemplates: "dash-nav-templates",
  dashNavFiles: "dash-nav-files",
  dashNavCounterparties: "dash-nav-counterparties",
  dashNavCompany: "dash-nav-company",
  dashNavExpert: "dash-nav-expert",
  dashNavRequests: "dash-nav-requests",
  dashNavIntakes: "dash-nav-requests",
  dashNavBilling: "dash-nav-billing",
  dashNavSettings: "dash-nav-settings",
  dashNavOrganization: "dash-nav-organization",
  dashNavIntegrations: "dash-nav-integrations",
  dashNavLogout: "dash-nav-logout",
  dashLangToggle: "dash-lang-toggle",
  fileUploadForm: "file-upload-form",
  fileInput: "file-input",
  fileUpload: "file-upload",
  fileRow: "file-row",
  fileDownload: "file-download",
  fileDelete: "file-delete",
  reviewPage: "review-page",
  reviewForm: "review-form",
  reviewFile: "review-file",
  reviewExisting: "review-existing",
  reviewRun: "review-run",
  reviewRow: "review-row",
  reviewFinding: "review-finding",
  settingsProfileForm: "settings-profile-form",
  settingsFullName: "settings-full-name",
  settingsCompany: "settings-company",
  settingsProfileSave: "settings-profile-save",
  settingsPasswordForm: "settings-password-form",
  settingsCurrentPassword: "settings-current-password",
  settingsNewPassword: "settings-new-password",
  settingsConfirmPassword: "settings-confirm-password",
  settingsPasswordSave: "settings-password-save",
  settingsLanguage: "settings-language",
  settingsNotificationsForm: "settings-notifications-form",
  settingsDealUpdates: "settings-deal-updates",
  settingsDocumentUpdates: "settings-document-updates",
  settingsProductUpdates: "settings-product-updates",
  settingsNotificationsSave: "settings-notifications-save",
  settingsDataExport: "settings-data-export",
  taskCreateForm: "task-create-form",
  taskTitle: "task-title",
  taskDueDate: "task-due-date",
  taskPriority: "task-priority",
  taskDeal: "task-deal",
  taskAssignee: "task-assignee",
  notificationsPage: "notifications-page",
  notificationsReadAll: "notifications-read-all",
  notificationRow: "notification-row",
  notificationDelete: "notification-delete",
  conversationPanel: "conversation-panel",
  conversationKind: "conversation-kind",
  conversationBody: "conversation-body",
  conversationSend: "conversation-send",
  conversationRow: "conversation-row",
  conversationReply: "conversation-reply",
  conversationDelete: "conversation-delete",
  externalSharingPanel: "external-sharing-panel",
  shareCreateForm: "share-create-form",
  shareDraft: "share-draft",
  shareRecipientEmail: "share-recipient-email",
  shareAllowSign: "share-allow-sign",
  shareCreate: "share-create",
  shareFreshLink: "share-fresh-link",
  shareRow: "share-row",
  shareRevoke: "share-revoke",
  publicSharePage: "public-share-page",
  publicSignForm: "public-sign-form",
  publicSignedState: "public-signed-state",
  expertSupportPage: "expert-support-page",
  expertRequestForm: "expert-request-form",
  expertTitle: "expert-title",
  expertDeal: "expert-deal",
  expertBrief: "expert-brief",
  expertSubmit: "expert-submit",
  expertRequestRow: "expert-request-row",
  expertRequestDetail: "expert-request-detail",
  expertQuote: "expert-quote",
  expertAcceptQuote: "expert-accept-quote",
  expertDelivery: "expert-delivery",
  adminExpertPage: "admin-expert-page",
  adminExpertRow: "admin-expert-row",
  adminExpertDetail: "admin-expert-detail",
  adminExpertActions: "admin-expert-actions",
  integrationsPage: "integrations-page",
  integrationKeyForm: "integration-key-form",
  integrationKeyCreate: "integration-key-create",
  integrationKeySecret: "integration-key-secret",
  integrationKeyRow: "integration-key-row",
  integrationWebhookForm: "integration-webhook-form",
  integrationWebhookCreate: "integration-webhook-create",
  integrationWebhookSecret: "integration-webhook-secret",
  integrationWebhookRow: "integration-webhook-row",
  integrationEventRow: "integration-event-row",
  documentWorkflowStatus: "document-workflow-status",
  documentSubmitReview: "document-submit-review",
  documentApprove: "document-approve",
  documentRequestChanges: "document-request-changes",
  documentMarkFinal: "document-mark-final",
  documentReopen: "document-reopen",
  organizationPage: "organization-page",
  organizationName: "organization-name",
  organizationSave: "organization-save",
  organizationInviteEmail: "organization-invite-email",
  organizationInviteRole: "organization-invite-role",
  organizationInvite: "organization-invite",
  organizationMemberRow: "organization-member-row",
  organizationAccept: "organization-accept",
  taskCreate: "task-create",
  taskFilter: "task-filter",
  taskRow: "task-row",
  taskToggle: "task-toggle",
  taskDelete: "task-delete",
  // Dashboard hero page
  dbQaCreate: "db-qa-create",
  dbQaReview: "db-qa-review",
  dbQaNewDeal: "db-qa-new-deal",
  dbQaDescribe: "db-qa-describe",
  dbActiveDeals: "db-active-deals",
  dbAttention: "db-attention",
  dbRecent: "db-recent",
  dbMembership: "db-membership",
  // Onboarding
  onbNext: "onb-next",
  onbBack: "onb-back",
  onbSkip: "onb-skip",
  onbFinish: "onb-finish",
  onbCompanyName: "onb-company-name",
  onbCompanyCountry: "onb-company-country",
  onbBusinessType: "onb-business-type",
  onbPrimaryActivity: "onb-primary-activity",
  onbLangEn: "onb-lang-en",
  onbLangIt: "onb-lang-it",
  onbLangDe: "onb-lang-de",
  onbAreaCommodity: "onb-area-commodity",
  onbAreaShipping: "onb-area-shipping",
  onbAreaChartering: "onb-area-chartering",
  onbAreaTradeFin: "onb-area-tradefin",
  onbAreaImportExport: "onb-area-importexport",
  onbAreaCorporate: "onb-area-corporate",
  onbAreaOther: "onb-area-other",
  // Stub pages
  stubComingSoon: "stub-coming-soon",
  stubNotifyBtn: "stub-notify-btn",
  // Admin
  adminNavOrgs: "admin-nav-orgs",
  adminNavUsers: "admin-nav-users",
  adminNavDeals: "admin-nav-deals",
  adminNavTemplates: "admin-nav-templates",
  adminNavIntake: "admin-nav-intake",
  adminNavEarly: "admin-nav-early",
  adminNavAudit: "admin-nav-audit",
  dealsNewBtn: "deals-new-btn",
  dealsTable: "deals-table",
  dealNewTitle: "deal-new-title",
  dealNewCounterparty: "deal-new-counterparty",
  dealNewType: "deal-new-type",
  dealNewValue: "deal-new-value",
  dealNewNotes: "deal-new-notes",
  dealNewSubmit: "deal-new-submit",
  dealNewCancel: "deal-new-cancel",
  dealRow: "deal-row",
  dealStageSelect: "deal-stage-select",
  dealDeleteBtn: "deal-delete-btn",

  // Drafting
  draftTemplateSelect: "draft-template-select",
  draftLanguageSelect: "draft-language-select",
  draftAddParam: "draft-add-param",
  draftGenerate: "draft-generate",
  draftOutput: "draft-output",
  draftCopy: "draft-copy",
  draftManualStart: "draft-manual-start",
  draftSave: "draft-save",
  draftExportDocx: "draft-export-docx",
  draftExportPdf: "draft-export-pdf",

  // Templates
  tplSearch: "tpl-search",
  tplCategoryAll: "tpl-cat-all",
  tplCategoryCommercial: "tpl-cat-commercial",
  tplCategoryDocumentary: "tpl-cat-documentary",
  tplCategoryShipping: "tpl-cat-shipping",
  tplCategoryManagement: "tpl-cat-management",
  tplCard: "tpl-card",
  tplUse: "tpl-use",

  // Deal detail
  dealDetail: "deal-detail",
  dealBackBtn: "deal-back-btn",
  dealDetailNewDraft: "deal-detail-new-draft",
  draftItem: "draft-item",
  draftExportDocx: "draft-export-docx",
  draftExportPdf: "draft-export-pdf",
  draftItemDelete: "draft-item-delete",
  draftItemEdit: "draft-item-edit",
  draftEditTitle: "draft-edit-title",
  draftEditNotes: "draft-edit-notes",
  draftEditSave: "draft-edit-save",
  draftEditCancel: "draft-edit-cancel",

  // Deals list search & sort
  dealsSearch: "deals-search",
  dealsSort: "deals-sort",

  // Intake status
  intakeStatusSelect: "intake-status-select",
};

export const HOME = { emergentLink: "emergent-link" };
